import { Link } from 'react-router-dom';
import { getMediaByType } from '@/lib/media';

const ENTRIES = [
  {
    type: 'movie',
    label: '电影',
    icon: 'ri-film-line',
    desc: '院线热映与经典佳片，快速了解最新影视内容',
    cover:
      'https://readdy.ai/api/search-image?query=Modern%20cinema%20hall%20with%20a%20large%20glowing%20screen%20and%20rows%20of%20empty%20seats%2C%20deep%20navy%20tones%20and%20warm%20amber%20accent%20lighting%2C%20cinematic%20atmosphere%2C%20minimalist%20elegant%20composition%2C%20highly%20detailed&width=800&height=500&seq=entry-movie&orientation=landscape',
  },
  {
    type: 'tv',
    label: '电视剧',
    icon: 'ri-tv-2-line',
    desc: '热门剧集持续更新，古装悬疑都市一网打尽',
    cover:
      'https://readdy.ai/api/search-image?query=Cozy%20living%20room%20at%20night%20with%20a%20television%20casting%20a%20soft%20blue%20glow%2C%20deep%20navy%20and%20warm%20amber%20tones%2C%20comfortable%20cinematic%20atmosphere%2C%20minimalist%20elegant%20composition%2C%20highly%20detailed&width=800&height=500&seq=entry-tv&orientation=landscape',
  },
  {
    type: 'variety',
    label: '综艺',
    icon: 'ri-mic-line',
    desc: '真人秀音乐美食选秀，掌握最新一季看点',
    cover:
      'https://readdy.ai/api/search-image?query=Colorful%20television%20studio%20stage%20with%20glowing%20lights%20and%20empty%20microphone%20stands%2C%20deep%20navy%20and%20vivid%20amber%20tones%2C%20energetic%20cinematic%20atmosphere%2C%20minimalist%20composition%2C%20highly%20detailed&width=800&height=500&seq=entry-variety&orientation=landscape',
  },
];

export default function CategoryEntries() {
  return (
    <section className="w-full px-4 md:px-8 mt-10 md:mt-14">
      <div className="flex items-end justify-between mb-5">
        <div>
          <h2 className="text-xl md:text-2xl font-bold text-foreground-950">分类快捷入口</h2>
          <p className="mt-1 text-sm text-foreground-500">按类型快速找到你感兴趣的内容</p>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6">
        {ENTRIES.map((entry) => {
          const count = getMediaByType(entry.type).length;
          return (
            <Link
              key={entry.type}
              to={`/category/${entry.type}`}
              className="group relative block h-[180px] md:h-[200px] rounded-lg overflow-hidden cursor-pointer"
            >
              <img
                src={entry.cover}
                alt={`${entry.label}分类入口`}
                title={`${entry.label} - 神马视频分类导航`}
                className="absolute inset-0 w-full h-full object-cover object-center group-hover:scale-105 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-primary-950/90 via-primary-950/50 to-primary-950/20"></div>
              <div className="relative h-full flex flex-col justify-end p-5">
                <div className="flex items-center gap-2 text-background-50">
                  <span className="w-10 h-10 flex items-center justify-center rounded-md bg-accent-500 text-primary-950">
                    <i className={`${entry.icon} text-xl`}></i>
                  </span>
                  <h3 className="text-lg md:text-xl font-bold">{entry.label}</h3>
                  <span className="ml-1 px-2 py-0.5 rounded-full text-xs bg-background-50/20 text-background-50">
                    {count} 部
                  </span>
                </div>
                <p className="mt-2 text-sm text-background-200 line-clamp-1">{entry.desc}</p>
                <span className="mt-3 inline-flex items-center gap-1 text-sm font-medium text-accent-400">
                  立即浏览
                  <i className="ri-arrow-right-line group-hover:translate-x-1 transition-transform"></i>
                </span>
              </div>
            </Link>
          );
        })}
      </div>
    </section>
  );
}